import controller from '../../../../Scripts/Controller.js';
import Swiper from 'swiper';
import enquire from 'enquire.js';

function Categories(container) {
    var slider;
    function init() {

        handleDisplayTitle();        



        updateCategoryLinks();
        updateBreadcrumbs();

        var items = container.querySelectorAll('.hero__categories__item');
        container.classList.add('swiper-container');
        container.querySelector('.hero__categories__items.mobile-view').classList.add('swiper-wrapper');
        for (var i = 0; i < items.length; i++) {
            items[i].classList.add('swiper-slide');
        }
        slider = initSlider();


        window.addEventListener('FilterUpdate', handleFilterUpdate);


        window.addEventListener("resize", handleDisplayTitle);
        function handleDisplayTitle() {
            var anchorTags = document.querySelectorAll('.hero__categories__item__anchor');
            for (let i = 0; i < anchorTags.length; i++) {
                if (isEllipsisActive(anchorTags[i].querySelectorAll(".cut-text-anchor")[0])) {
                    let cutText = anchorTags[i].querySelectorAll(".cut-text-anchor")[0].innerText;
                    anchorTags[i].title = cutText;
                }
                else {
                    anchorTags[i].title = "";
                }
            }
        }
        function isEllipsisActive(e) {
            return (e.offsetWidth < e.scrollWidth);
        }

        function initSlider() {
            return new Swiper ('.swiper-container', {
            observer: true,
            loop: false,
            pagination: '.swiper-pagination',
            paginationClickable: true,
            slidesPerView: 1,
            slidesPerGroup: 1//,
            //breakpoints: {
            //  360: {
            //    slidesPerView: 3,
            //    slidesPerGroup: 3,
            //  },
            //  700: {
            //    slidesPerView: 3,
            //    slidesPerGroup: 3,
            //  }
            //}
          });
        }

        function updateSlider() {
            if (container.classList.contains('swiper-container')) {
                var items = container.querySelectorAll('.hero__categories__item');
                container.querySelector('.hero__categories__items').classList.add('swiper-wrapper'); // l�gg bara till p� mobil
                for (var i = 0; i < items.length; i++) {
                    items[i].classList.add('swiper-slide');
                }
                slider.update();
            }
        }

        function handleFilterUpdate(e) {
            updateSlider();
            updateCategoryLinks(e);
            updateBreadcrumbs();
        }
    
        function updateCategoryLinks(e) {
            var categoryLinks = document.getElementsByClassName('hero__categories__item__anchor');

            for (var i = 0; i < categoryLinks.length; i++) {
                var newUrl = "";
                if (categoryLinks[i].getAttribute("data-originalurl").indexOf("?") >= 0) {
                    newUrl = categoryLinks[i].getAttribute("data-originalurl") + "&" + window.location.search.substr(1);
                } else {
                    newUrl = categoryLinks[i].getAttribute("data-originalurl") + window.location.search;
                }
                var newUrlfixed = removeParams(newUrl, "hidetypefilter");
                categoryLinks[i].setAttribute("href", newUrlfixed);
            }
        }

        function updateBreadcrumbs() {
            var crumbLinks = document.getElementsByClassName('local-nav__item__link');
            if (crumbLinks) {
                for (var i = 0; i < crumbLinks.length; i++) {
                    if (crumbLinks[i]) {

                            var qs = window.location.search;
                            crumbLinks[i].href = crumbLinks[i].href.substring(crumbLinks[i].href.indexOf('?'), 0) + qs ;
                        
                    }
                }
            }
        }
        function removeParams(origUrl, sParam) {

            let url = new URL(origUrl, document.baseURI);
            let params = new URLSearchParams(url.search);
            params.delete(sParam);
            url.search = params.toString();

            // the new url string
            return url.toString();

        }

      }
      return {
        init:init
      }
}

function handleSearch(e) {

    clearTimeout(textFieldTimer);

    var query = this.value;


    if (query.length > 2) {

        textFieldTimer = setTimeout(function () {
            showSearchContainerAndFetchResult(query);
        },
            500);
    }
    else {
        removeSearchContainer();
    }
}

function showSearchContainerAndFetchResult(query) {
    input.setAttribute('data-loading', 'true');
    fetchResult(query).then((result) => {
        input.setAttribute('data-loading', 'false');
        if (!searchContainer) {

            searchContainer = document.createElement('div');
            searchContainer.classList.add('autosuggest');
            input.insertAdjacentElement('afterend', searchContainer);
            input.classList.add('autosuggest-active');
            document.body.addEventListener('click', removeSearchContainer);
            document.addEventListener('keydown', handleEscKeyPress);
            searchContainer.addEventListener('click', (e) => {
                e.stopPropagation();
            })
        }
        searchContainer.innerHTML = result;
        var suggestionList = document.getElementsByClassName("autosuggest_suggestion");
    })


}

controller.add('Categories', Categories);
export default Categories;
